import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import IdolFilterForm from './IdolFilterForm';

const IdolFilterSidebar = ({ filters, onFilterChange, onClearFilters }) => {
  const { t } = useTranslation();

  return (
    <div className="bg-white rounded p-3 mb-4">
      {/* 標題 + 重置按鈕 */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="mb-0">{t('filter')}</h5>
        <Button
          variant="outline-primary"
          size="sm"
          onClick={onClearFilters}
          className="rounded-pill"
        >
          {t('reset')}
        </Button>
      </div>

      {/* 共用篩選表單 */}
      <IdolFilterForm filters={filters} onFilterChange={onFilterChange} uniqueId="_sidebar" />
    </div>
  );
};

export default IdolFilterSidebar;
